import { ComposedTheme } from '@glu/theming';

export default ({ palette }: ComposedTheme) => ({
  content: {
    backgroundColor: {
      defaultBackgroundColor: palette.background,
    },
    color: {
      negativeColor: palette.text.dark,
      positiveColor: palette.text.light,
    },
    lineHeight: '26px',
  },
  border: `1px solid ${palette.accent}`,
  borderRadius: 6,
  boxShadow: 'none',
  // @Unused property - Will be removed in GLU-7500
  colorLabel: palette.text.dark,
  fontSize: 14,
  title: {
    textTransform: undefined,
    backgroundColor: palette.grey.G100,
    // @Unused property, no border on title - Will be removed in GLU-7500
    borderRadius: [6, 6, 0, 0],
    margin: [-16, -16, 0, -16],
    padding: [8, 14],
  },
});
